import type { Block } from "../blocks/Block";
import { BaseScreen } from "./BaseScreen";
import { CoreHeader } from "./components/CoreHeader";
import { BlockRegistry } from "../blocks/BlockRegistry";
import { registerBlocks } from "../blocks/registerBlocks";
import { KrokHeaderBlock } from "../blocks/KrokHeaderBlock";
import type { StateStore } from "../app/state/StateStore";


/**
 * События CoreScreen.
 */
export interface CoreScreenEvents {

    completeClicked(): Promise<void>;

    prevClicked(): void;

    nextClicked(): void;

    entryClicked(): void;

    listClicked(): void;

    userClicked(): void;

}

/**
 * Экран прохождения Krok.
 *
 * Владеет Block данного экрана.
 */
export class CoreScreen extends BaseScreen {

    private readonly store: StateStore;

    private readonly blocks: Block[] = [];

    private readonly events: CoreScreenEvents;


    constructor(
        store: StateStore,
        private readonly blockRegistry: BlockRegistry,
        private readonly services: BlockServices,
        events: CoreScreenEvents
    ) {

        super();

        this.store = store;
        this.events = events;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        this.blocks.push(
            new KrokHeaderBlock(
                this.store
            )
        );

        const krok =
            this.store.getState().krok;

        if (!krok) {
            return;
        }

        for (const [taskIndex, task] of krok.tasks.entries()) {

            if (!this.blockRegistry.has(task.type)) {
                continue;
            }

            this.blocks.push(

                this.blockRegistry.create(
                    task,
                    taskIndex,
                    this.store
                )

            );

        }

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        for (const block of this.blocks) {
            block.unmount();
        }

        this.blocks.length = 0;

        super.unmount();

    }


    private renderBottomNavigation(): HTMLElement {

        const state =
            this.store.getState();

console.log("BOTTOM STATE", state.krok);            

        const wrapper =
            document.createElement("div");

        wrapper.className =
            "bottom-arrows";

        if (state.krok) {

            const createIcon = (
                src: string,
                alt: string
            ) => {

                const img =
                    document.createElement("img");

                img.src = src;
                img.alt = alt;

                return img;

            };

            // ◄ PREV

            if (state.krok.prev_krok_id) {

                const prev =
                    document.createElement("button");

                prev.addEventListener(
                    "click",
                    () => {

                        this.events.prevClicked();

                    }
                );

                prev.className =
                    "arrow-btn";

                prev.appendChild(
                    createIcon(
                        "/img/prev.png",
                        "prev"
                    )
                );

                wrapper.appendChild(prev);

            } else {

                wrapper.appendChild(
                    document.createElement("div")
                );

            }

            // ⏩ ENTRY

            if (state.krok.next_krok_id !== null) {

                const entry =
                    document.createElement("button");

                entry.addEventListener(
                    "click",
                    () => {

                        this.events.entryClicked();

                    }
                );

                entry.className =
                    "arrow-btn";

                entry.appendChild(
                    createIcon(
                        "/img/entry.png",
                        "entry"
                    )
                );

                wrapper.appendChild(entry);

            } else {

                wrapper.appendChild(
                    document.createElement("div")
                );

            }

            // ► NEXT

            if (state.krok.next_krok_id) {

                const next =
                    document.createElement("button");

                next.addEventListener(
                    "click",
                    () => {

                        this.events.nextClicked();

                    }
                );

                next.className =
                    "arrow-btn";

                next.appendChild(
                    createIcon(
                        "/img/next.png",
                        "next"
                    )
                );

                wrapper.appendChild(next);

            } else {

                wrapper.appendChild(
                    document.createElement("div")
                );

            }

        }
console.log("BOTTOM HTML", wrapper.innerHTML);

        return wrapper;

    }


    private renderCompleteButton(): HTMLElement {

        const button =
            document.createElement("button");

        button.textContent =
            "Завершити Крок";

        button.addEventListener(
            "click",
            async () => {

                await this.events.completeClicked();

            }
        );

        return button;

    }

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "core-screen";

        // =========================
        // Header
        // =========================

        const header =
            new CoreHeader(
                this.events
            );

        header.mount();

        root.appendChild(
            header.getRoot()
        );

        // =========================
        // Content
        // =========================

        const content =
            document.createElement("div");

        content.className =
            "content";

        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            content.appendChild(
                block.getRoot()
            );

        }

        content.appendChild(
            this.renderCompleteButton()
        );

        // =========================
        // Bottom
        // =========================

        const bottom =
            this.renderBottomNavigation();

        // =========================
        // Assemble
        // =========================

        root.appendChild(header.getRoot());
        root.appendChild(content);
        root.appendChild(bottom);

        return root;

    }

}